function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#ee1c25"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.673 9.073 5 7 4.326 9.073 2.146 9.073 3.909 10.354 3.235 12.427 4.999 11.146 6.763 12.427 6.089 10.353 7.852 9.073 5.673 9.073",
    style: {
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.85 7.352 10.224 7.975 10.288 7.251 10.995 7.088 10.327 6.804 10.391 6.08 9.913 6.628 9.245 6.344 9.619 6.967 9.141 7.515 9.85 7.352",
    style: {
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.726 9.266 11.829 9.985 12.169 9.343 12.884 9.467 12.379 8.946 12.718 8.304 12.066 8.624 11.56 8.102 11.663 8.821 11.01 9.141 11.726 9.266",
    style: {
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.366 12.105 12.939 11.657 12.212 11.683 11.963 11 11.763 11.699 11.037 11.725 11.64 12.131 11.441 12.829 12.013 12.382 12.615 12.787 12.366 12.105",
    style: {
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.319 13.79 10.353 13.064 9.9 13.631 9.22 13.375 9.619 13.982 9.166 14.549 9.866 14.357 10.265 14.964 10.299 14.238 11 14.046 10.319 13.79",
    style: {
      fill: "#ff0"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/CN.2ed353638806db2976d5fbc3be8f96fa.svg";
export { ForwardRef as ReactComponent };